import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setVirtualKeyboard } from "../../actions";

// Keyboard Package
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

// Style
import "../../App.css";

// Material-UI
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

// Other
import { colors } from "../../constants/colors";

const VirtualKeyboard = (props) => {
  const useStyles = makeStyles({
    root: {
      // zIndex: "1",
      bottom: "0px",
      "& .MuiSnackbarContent-root": {
        padding: "0px",
        display: "flex",
        flexDirection: "column-reverse",
        backgroundColor: (props) => colors[props.theme].headerBkg,
      },
      "& .MuiSnackbarContent-message": {
        padding: "0px",
      },
      "& .MuiSnackbarContent-action": {
        marginRight: "0px",
        paddingLeft: "0px",
        alignSelf: "flex-start",
      },
    },
    button: {
      color: "white",
      padding: "3px 3px 0px 3px",
    },
  });

  const classes = useStyles(props);

  const virtualKeyboardRef = React.useRef();

  const [virtualKeyboardLayout, setVirtualKeyboardLayout] = React.useState({
    layoutName: "default",
  });

  React.useEffect(() => {
    if (virtualKeyboardRef.current) {
      handleSetInput(virtualKeyboardRef.current, props.keyboardInputUpdate);
    }
  }, [props.keyboardInputUpdate]);

  React.useEffect(() => {
    if (props.numberPad) {
      setVirtualKeyboardLayout({ layoutName: "numberPad" });
    } else {
      setVirtualKeyboardLayout({ layoutName: "default" });
    }
  }, [props.numberPad]);

  function handleClose() {
    props.setVirtualKeyboard(false);
  }

  function handleSetInput(r, newInputValues) {
    for (const [key, value] of Object.entries(newInputValues)) {
      r.setInput(value, key);
    }
  }

  function handleLayoutChange(button) {
    switch (button) {
      case "{abc}":
        setVirtualKeyboardLayout({ layoutName: "default" });
        break;
      case "{&123}":
        setVirtualKeyboardLayout({ layoutName: "other" });
        break;
      case "{shift}":
        setVirtualKeyboardLayout({
          layoutName:
            virtualKeyboardLayout.layoutName === "default"
              ? "shift"
              : "default",
        });
        break;
      default:
    }
  }

  return (
    <Snackbar
      open={props.open}
      className={classes.root}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: props.anchor, // Snackbar position can be changed by the element who is calling the snackbar
      }}
      TransitionComponent={Slide}
      action={
        <IconButton
          className={classes.button}
          size="small"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      message={
        <Keyboard
          // Reference to the keyboard instance. Reference is used to set keyboard input
          keyboardRef={(r) => {
            handleSetInput(r, props.keyboardInitialInput);
            virtualKeyboardRef.current = r;
          }}
          // Layout name allows switching between the different keyboard layouts: default, shift, other
          layoutName={virtualKeyboardLayout.layoutName}
          // Input can be assigned names. This allows one keyboard instance to be used for multiple textfields
          inputName={props.keyboardInputName}
          // Callback function for the input
          onChange={(inputObj) => {
            props.keyboardChange(inputObj);
          }}
          theme={
            props.theme === "light"
              ? "hg-theme-default hg-layout-default lightTheme"
              : "hg-theme-default hg-layout-default darkTheme"
          }
          onKeyPress={(button) => {
            if (
              button === "{shift}" ||
              button === "{&123}" ||
              button === "{abc}"
            ) {
              handleLayoutChange(button);
            } else if (button === "{enter}" && props.keyboardEnter) {
              props.keyboardEnter();
            }
          }}
          // Outline of the different layouts. Each key is separated by a space
          layout={{
            default: [
              "q w e r t y u i o p {backspace}",
              "a s d f g h j k l ' {enter}",
              "{shift} z x c v b n m , . ? {shift}",
              "{&123} {space}",
            ],
            shift: [
              "Q W E R T Y U I O P {backspace}",
              'A S D F G H J K L " {enter}',
              "{shift} Z X C V B N M : ; ! {shift}",
              "{&123} {space}",
            ],
            other: [
              "1 2 3 4 5 6 7 8 9 0 {backspace}",
              "` ~ ! @ # $ % ^ & * {enter}",
              "= / \\ [ ] - _ < > ( ) +",
              "{abc} {space}",
            ],
            numberPad: ["1 2 3", "4 5 6", "7 8 9", "0 {backspace}"],
          }}
          // Custom themes can be assigned to specific buttons
          buttonTheme={[
            {
              class: "hg-back",
              buttons: "{backspace}",
            },
            {
              class: "hg-enter",
              buttons: "{enter}",
            },
            {
              class: "hg-space",
              buttons: "{space}",
            },
            {
              class: "hg-123",
              buttons: "{&123} {abc}",
            },
          ]}
          // Buttons can have different display views
          display={{
            "{backspace}": "⌫",
            "{enter}": "↵",
            "{shift}": "⇧",
            "{abc}": "abc",
            "{&123}": "&123",
            "{space}": " ",
          }}
        />
      }
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setVirtualKeyboard }, dispatch);
};

const mapStateToProps = (state) => {
  return {
    open: state.utility.virtualKeyboard,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VirtualKeyboard);
